module.exports = __webpack_public_path__ + "static/img/ic_serviceflow_a.73899316.png";